import ProductInfo from '@components/molecules/ProductInfo/ProductInfo'
import PropTypes from 'prop-types'
import PropTypesUtils from '@utils/propTypes'
import c from 'classnames'
import React from 'react'
import styles from './Split.module.scss'

const Split = ({ children, hasFullWidth }) => (
  <div className={c(styles.base, 'u-pt')}>
    {React.Children.toArray(children)[0]}
    <div className={styles.background}>
      {React.Children.toArray(children)[2]}
    </div>

    <div className={styles.content}>
      <div className={c('o-grid', styles.baseGrid, styles.fullHeight)}>
        <div
          className={c(
            hasFullWidth
              ? 'o-grid__col u-10/14@md  u-push-1/14@md'
              : 'o-grid__col u-6/14@md u-pull-4/14@md u-push-1/14@md',
            styles.fullHeight
          )}
        >
          {React.Children.toArray(children)[1]}
        </div>
        <div className={c('o-grid__col u-3/14@md', styles.fullHeight)}>
          <div className={styles.left}>
            <ProductInfo />
          </div>
        </div>
      </div>
    </div>
  </div>
)

Split.defaultProps = {}
Split.propTypes = {
  children: PropTypesUtils.children.isRequired,
  hasFullWidth: PropTypes.bool,
}

export default Split
